import { getCookie } from 'helpers/cookies.helper'
import { LinksApi } from 'api'
import { tabsObject } from './constants'

const API_TABS_ERROR = 'Error on get sidebar tabs list'

const baseUrl = `/home/sidebar`
const sortByOrder = (entry: any) => entry.sort((a, b) => a.order - b.order)

export interface IFilter {
  type: string
  url: string
  prefix: string
  name: string[]
}

export interface IDashboard {
  code?: string
  show?: boolean
  order?: number
  filters?: IFilter[]
}

export interface ITab {
  id: string
  url: string
  icon?: string
  translation: string
  image?: string
  token?: string
}

class SidebarTab {
  id: string
  icon?: string
  url: string
  translation: string
  image?: string
  token?: string
  action_type?: string

  constructor(data: ITab) {
    this.id = data.id
    this.icon = data.icon
    this.url = data.url
    this.translation = data.translation
    this.image = data.image
    this.token = data.token || undefined
  }
}

export const getSidebarTabs = async () => {
  const response = await LinksApi.get(baseUrl)
  if (!response) throw new Error(API_TABS_ERROR)
  const defaultSections = response.data.filter(
    (section) => section.section === 'default' || section.section === 'start'
  )
  const appsSections = response.data.filter(
    (section) => section.section === 'app'
  )
  const sorting_start = sortByOrder(defaultSections)
  const sorting_apps = sortByOrder(appsSections)

  const tabs_results = (tabList: any[]) => {
    return tabList.map((item) => {
      const tab_found = tabsObject.find((tab) => tab.id === item.id)
      if (!tab_found) throw new Error(`Item ${item} not found`)
      const needToken = ['profile', 'organigram'].includes(tab_found.id)
      return new SidebarTab({
        ...tab_found,
        token: item.token,
        url: needToken
          ? `${tab_found.url}/${getCookie(
              process.env.REACT_APP_JWT_COOKIE as string
            )}`
          : (tab_found.url as any),
      } as any)
    })
  }
  return {
    start: tabs_results(sorting_start),
    apps: tabs_results(sorting_apps),
  }
}
